import React from "react";
import { CTAButton, SectionLabel, Reveal } from "../primitives";
import { Section, BODY_DARK } from "../shared";
import { touchpoints } from "../content";
import { usePricing } from "@/lib/pricing";

const infoItems = (founding) => [
  { l: "Spielstart", v: founding ? "5. Oktober 2026" : "Direkt ab Deiner Buchung" },
  { l: "Dauer", v: "6 Monate" },
  { l: "Spielcharakter", v: "Ko-Kreation statt Konkurrenz" },
];

export default function AblaufSection() {
  const { founding } = usePricing();
  return (
    <Section id="ablauf" testId="ablauf-section" className="bg-espresso py-24 text-gold md:py-36">
      <SectionLabel color="gold" testId="ablauf-label">Was Dich erwartet</SectionLabel>
      <Reveal>
        <h2 className="mb-16 font-heading text-4xl font-700 uppercase tracking-tight text-gold md:text-6xl" style={{ fontWeight: 700 }}>
          So läuft es ab
        </h2>
      </Reveal>
      <Reveal delay={0.06}>
        <h3 className="mb-6 font-heading text-2xl font-700 uppercase tracking-tight text-cognac-light md:text-3xl" style={{ fontWeight: 700 }}>
          Die Module (Self-Study)
        </h3>
        <p className={`${BODY_DARK} mb-16 max-w-3xl`}>
          {founding
            ? "Ab dem 5. Oktober droppen wir wöchentlich neue Module, mit kurzen Videoanleitungen, Worksheets zur individuellen Reflexion und Meditationen. Live mitmachen oder in Deinem eigenen Tempo."
            : "Deine 6 Monate starten direkt mit Deiner Buchung – Du steigst einfach in den laufenden Prozess ein. Wöchentlich droppen neue Module, mit kurzen Videoanleitungen, Worksheets zur individuellen Reflexion und Meditationen. Live mitmachen oder in Deinem eigenen Tempo."}
        </p>
      </Reveal>
      <Reveal delay={0.06}>
        <h3 className="mb-10 font-heading text-2xl font-700 uppercase tracking-tight text-cognac-light md:text-3xl" style={{ fontWeight: 700 }}>
          5 Live Touchpoints im Monat
        </h3>
      </Reveal>
      <div className="mb-10 space-y-px">
        {touchpoints.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.05}>
            <div className="grid gap-3 border-t border-cognac/40 py-6 md:grid-cols-12 md:gap-8">
              <div className="flex items-baseline gap-4 md:col-span-5">
                <span className="font-heading text-sm font-700 text-cognac-light" style={{ fontWeight: 700 }}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-heading text-lg font-600 uppercase tracking-tight text-gold md:text-xl" style={{ fontWeight: 600 }}>
                  {t}
                </span>
              </div>
              <p className="font-body text-base leading-[1.7] text-gold/80 md:col-span-7 md:text-lg">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.08}>
        <p className="mb-16 max-w-3xl font-body text-base italic leading-[1.7] text-cognac-light md:text-lg">
          Alle Live Calls finden über Zoom statt und werden aufgezeichnet.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <div data-testid="info-box" className="border-2 border-cognac-light bg-cognac-2">
          <div className="grid grid-cols-1 md:grid-cols-3">
            {infoItems(founding).map((it) => (
              <div key={it.l} className="border-cognac-light/40 p-7 [&:not(:last-child)]:border-b md:[&:not(:last-child)]:border-b-0 md:[&:not(:last-child)]:border-r">
                <p className="mb-3 font-heading text-[11px] font-700 uppercase tracking-[0.24em] text-gold/80" style={{ fontWeight: 700 }}>
                  {it.l}
                </p>
                <p className="font-heading text-xl font-700 uppercase leading-tight tracking-tight text-white md:text-2xl" style={{ fontWeight: 700 }}>
                  {it.v}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.14}>
        <div className="mt-12">
          <CTAButton variant="gold" testId="ablauf-cta-button">Let's Play</CTAButton>
        </div>
      </Reveal>
    </Section>
  );
}
